import { DataBean } from "../DataBean";

export class PayrollType extends DataBean {


    public async getPayrollTypeCatalog(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollTypeCatalog_Number", [id]);
    }

    

 
}